class MobileNavDrawer extends HTMLElement {
  connectedCallback() {
    this.levelsContainer = this.querySelector('[data-levels]');
    this.titleEl = this.querySelector('[data-drawer-title]');
    this.backButton = this.querySelector('[data-drawer-back]');
    this.stack = []; // { el, title }

    this.addEventListener('click', this.#onClick.bind(this));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !this.hidden) this.close();
    });

    const rootLevel = this.querySelector('[data-level]');
    if (rootLevel) {
      rootLevel.classList.add('is-active');
      this.stack.push({ el: rootLevel, title: this.titleEl ? this.titleEl.textContent : '' });
    }
  }

  #onClick(event) {
    if (event.target.closest('[data-drawer-close]')) {
      event.preventDefault();
      this.close();
      return;
    }

    const menuLink = event.target.closest('[data-menu-item]');
    if (menuLink) {
      const key = menuLink.getAttribute('data-menu-item');
      const source = document.querySelector(`mega-menu-panel[data-menu-item="${key}"] .mobile-menu-source [data-level]`);
      if (source) {
        event.preventDefault();
        const clone = source.cloneNode(true);
        clone.hidden = false;
        this.#pushLevel(clone, menuLink.textContent.trim());
      }
      // If no mobile source exists, let the link navigate normally.
      return;
    }

    const subTrigger = event.target.closest('[data-sublevel-trigger]');
    if (subTrigger) {
      event.preventDefault();
      const id = subTrigger.getAttribute('data-sublevel-trigger');
      const original = subTrigger.parentElement.querySelector(`[data-sublevel="${id}"] [data-level]`);
      if (original) {
        const clone = original.cloneNode(true);
        clone.hidden = false;
        const title = original.parentElement.getAttribute('data-sublevel-title') || '';
        this.#pushLevel(clone, title);
      }
      return;
    }

    if (event.target.closest('[data-drawer-back]')) {
      event.preventDefault();
      this.#popLevel();
    }
  }

  #pushLevel(levelEl, title) {
    const current = this.stack[this.stack.length - 1];
    if (current) current.el.classList.add('is-previous');

    levelEl.classList.add('is-active');
    this.levelsContainer.appendChild(levelEl);
    this.stack.push({ el: levelEl, title });

    if (this.titleEl) this.titleEl.textContent = title;
    if (this.backButton) this.backButton.hidden = this.stack.length < 2;
  }

  #popLevel() {
    if (this.stack.length < 2) return;

    const removed = this.stack.pop();
    removed.el.classList.remove('is-active');
    removed.el.addEventListener(
      'transitionend',
      () => {
        if (removed.el.parentElement) removed.el.remove();
      },
      { once: true }
    );

    const current = this.stack[this.stack.length - 1];
    current.el.classList.remove('is-previous');

    if (this.titleEl) this.titleEl.textContent = current.title;
    if (this.backButton) this.backButton.hidden = this.stack.length < 2;
  }

  open() {
    this.hidden = false;
    requestAnimationFrame(() => this.classList.add('is-open'));
    document.documentElement.classList.add('mobile-nav-drawer-open');
  }

  close() {
    this.classList.remove('is-open');
    document.documentElement.classList.remove('mobile-nav-drawer-open');
    // Reset back to level 0 once the closing transition ends.
    const onEnd = () => {
      this.hidden = true;
      while (this.stack.length > 1) this.#popLevel();
      this.removeEventListener('transitionend', onEnd);
    };
    this.addEventListener('transitionend', onEnd);
  }
}

if (!customElements.get('mobile-nav-drawer')) {
  customElements.define('mobile-nav-drawer', MobileNavDrawer);
}

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-drawer-open]');
  if (!opener) return;
  const drawer = document.querySelector('mobile-nav-drawer');
  if (drawer) drawer.open();
});